import * as React from "react";
import Box from "@mui/material/Box";
import {
   DataGrid,
   GridColDef,
   GridRenderCellParams,
   GridTreeNodeWithRender,
} from "@mui/x-data-grid";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { LinksState } from "../../../features/links/links";
import DashboardTemplate from "../../../components/TemplateAdmin/DashboardTemplate";

import EditIcon from "@mui/icons-material/Edit";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import { setDialog } from "../../../features/dialog/dialogSlice";

const formatDate = (dateString: number | string) => {
   const date = new Date(dateString);
   return date.toLocaleDateString("en-US", {
      year: "2-digit",
      month: "short",
      day: "2-digit",
   });
};

export default function () {
   const dispatch = useAppDispatch();
   let links: any = useAppSelector((state: any) => state.links);

   const rows = links.arr;

   const handleEdit = (id: number) => {
      const editRow = links.arr.filter((a: any) => a.id === id);
      console.log(editRow[0]);
      dispatch(
         setDialog({
            open: true,
            title: "Edit Link",
            content: "Edit",
            params: {
               row: editRow[0],
               tableName: "links",
            },
         })
      );
      // Handle edit action
   };

   const handleDelete = (id: number) => {
      // Handle delete action
   };

   const handleView = (id: number) => {
      const viewRow = links.arr.filter((a: any) => a.id === id);
      dispatch(
         setDialog({
            open: true,
            title: `View Link`,
            content: "View",
            params: {
               row: viewRow[0],
               tableName: "links",
            },
         })
      );
   };

   const columns: GridColDef[] = [
      {
         field: "actions",
         headerName: "Actions",
         width: 120,
         renderCell: (
            params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>
         ) => (
            <>
               <IconButton
                  aria-label='delete'
                  size='small'
                  color='primary'
                  onClick={() => handleEdit(params.row.id)}
               >
                  <EditIcon fontSize='inherit' />
               </IconButton>
               <IconButton
                  aria-label='delete'
                  size='small'
                  color='primary'
                  onClick={() => handleView(params.row.id)}
               >
                  <RemoveRedEyeIcon fontSize='inherit' />
               </IconButton>
               <IconButton
                  aria-label='delete'
                  size='small'
                  color='primary'
                  onClick={() => handleDelete(params.row.id)}
               >
                  <DeleteIcon fontSize='inherit' />
               </IconButton>
            </>
         ),
      },
      {
         field: "id",
         headerName: "ID",
         width: 30,
      },
      { field: "link_id", headerName: "Link ID", width: 120 },
      { field: "listing_id", headerName: "Listing ID", width: 120 },
      { field: "link_type", headerName: "Link Type", width: 200 },
      { field: "link_title", headerName: "Link Title", width: 200 },
      { field: "link_url", headerName: "Link URL", width: 300 },
      {
         field: "createdAt",
         headerName: "Created At",
         width: 180,
         valueFormatter: (params: any) => formatDate(params.value),
      },
      {
         field: "updatedAt",
         headerName: "Updated At",
         width: 180,
         valueFormatter: (params: any) => formatDate(params.value),
      },
      { field: "feature", headerName: "Feature", width: 150 },
      { field: "featureObj", headerName: "Feature Object", width: 200 },
      { field: "isAuto", headerName: "Is Auto", width: 120 },
      { field: "isDeleted", headerName: "Is Deleted", width: 120 },
   ];

   React.useEffect(() => {
      // reload if links state changes
   }, [links.arr]);

   return (
      <DashboardTemplate title={"Links Grid View"}>
         <DataGrid
            density='compact'
            rows={rows}
            columns={columns}
            initialState={{
               pagination: {
                  paginationModel: {
                     pageSize: 15,
                  },
               },
            }}
            pageSizeOptions={[5, 10, 15, 20, 25, 50]}
            disableRowSelectionOnClick
         />
      </DashboardTemplate>
   );
}
